<style media="screen" scoped>

#side-menu .router-link-active {
    background: #eee;
}

.sidebar {
    width: 200px;
}

@media (min-width: 768px) {
    #page-wrapper {
        position: inherit;
        margin: 0 0 0 200px;
        padding: 0 30px;
        border-left: 1px solid #e7e7e7;
    }
}

.is-opened{
  background: #606266;
}

</style>

<template>

<div class="navbar-default sidebar" role="navigation">
    <el-menu background-color="transparent"	 text-color="#fff" style="border-right: transparent;" :unique-opened="true" :default-active="defaultActive" :default-openeds="defaultOpeneds" @select="select" class="el-menu-vertical-demo">
        <el-submenu  v-if="menu.childMenu.length" :index="index+''" v-for="(menu,index) in datas">
            <template slot="title"><i :class="menu.icon"></i>&nbsp;&nbsp;{{menu.name}}</template>
            <template lang="html" v-for="(subMenu,subIndex) in menu.childMenu">
              <el-menu-item  v-if="subMenu.name!='武穴车展'&&subMenu.name!='本地车展' || subMenu.name=='武穴车展'&&channelId==189 || subMenu.name=='本地车展'&&channelId==271" :index="index+'-'+subIndex">
                <i :class="subMenu.icon" style="text-color:#fff;"></i>&nbsp;&nbsp;{{subMenu.name}}
              </el-menu-item>
            </template>

        </el-submenu>
    </el-menu>
    <!-- /.sidebar-collapse -->
</div>
<!-- /.navbar-static-side -->

</template>

<script>

import BasicPager from '../../../mixins/BasicPager'
import SysModel from '../../../framework/models/sysModel'
export default {
  name: 'menus',
  extends: BasicPager,
  data: function () {
    return {
      datas: [],
      defaultActive: '0-0',
      defaultOpeneds: ['0'],
      channelId: null
    }
  },
  created: function () {
    this.loadList()
    this.defaultActive = localStorage.menusIndex
    this.defaultOpeneds = [localStorage.menuPosition]

    if (this.loginInfo.loginPath === 'channel') {
      this.channelId = this.loginInfo.id
    }

    this.$router.beforeEach((to, from, next) => {
      // 判断当前切换的路由是哪个
      this.onRouterChanged(to)
      next(true)
    })
  },
  watch: {
    menuGroup: function () {
      this.loadList()
    }
  },
  props: {
    menuGroup: {
      type: Number,
      default: null
    }
  },
  methods: {
    onRouterChanged (to) {
      let datas = this.datas
      if (datas) {
        let length = datas.length
        for (let i = 0; i < length; i++) {
          let data = datas[i]
          let childMenu = data.childMenu
          let jLength = childMenu.length
          for (let j = 0; j < jLength; j++) {
            let menu = childMenu[j]
            let url = '/home/' + menu.url
            let path = to.path
            if (path.indexOf(url) === 0) {
              this.defaultActive = i + '-' + j
              this.defaultOpeneds = [i + '']
            }
          }
        }
      }
    },
    select: function (index) {
      let positions = index.split('-')
      let menuPosition = parseInt(positions[0])
      let subPosition = parseInt(positions[1])
      let menu = this.datas[menuPosition]
      let subMenu = menu.childMenu[subPosition]
      localStorage.menusIndex = index
      localStorage.menuPosition = menuPosition
      this.$router.push({
        path: '/home/' + subMenu.url
      })
    },

    loadList: function () {
      let _this = this
      let listener = {
        success: function (dataInfo) {
          let datas = dataInfo.datas
          _this.datas = datas

          // 默认显示第一个菜单组的第一个子菜单
          let url = datas[0].childMenu[0].url
          _this.$router.push({
            path: '/home/' + url
          })
          _this.defaultActive = '0-0'
          _this.defaultOpeneds = ['0']
        }
      }
      if (localStorage.userInfo) { SysModel.findNavigation(_this, listener) }
    }
  }
}

</script>
